import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios'
import Navbar from '../../home/navbar';

import Footer from '../../home/footer';
import comment_image from '../images/comment.png'
import love_image from '../images/love.png'
import Popup from 'reactjs-popup';

import { url } from '../../weburl';
import { CommentModal } from './commentModal';
import { CommentCard } from './comment_card';
import { CCollapse, CButton, CCardBody, CCard } from '@coreui/react'
import CountryContext from '../../home/country_context';
import moment from 'moment';
import './posts.css'
import { Link } from 'react-router-dom';


export const PostCard = (props) => {
    const contextData = useContext(CountryContext)
    const [posts, setPosts] = useState({})
    const [posts_loaded, setPostsLoaded] = useState(false)
    const [comment_modal, setCommentModal] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const [comments, setComments] = useState([])
    const [visible, setVisible] = useState(false)
    const [likes, setLikes] = useState(props.likes || 0)

    useEffect(() => {
        getComments()

    }, [])

    useEffect(()=> {
        getComments()
    }, [contextData.refreshCounter])

    const likeAPost = (e, id) => {
        e.preventDefault()
        setLikes(likes + 1)
        // setState({likes: likes + 1})

        axios
            .post(`${url}api/posts/like/${id}`)
            .then((res) => {
                // context.refresh()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const getComments = () => {
        var id = props.post_id
        console.log(id)
        console.log('calling get comments')
        axios
            .get(`${url}api/posts/${id}/comments`)
            .then((res) => {
                setComments(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const displayComments = () => {
        return Object.keys(comments).map((item) => {

            return <div className='w-100'>
                <CommentCard content={comments[item].content}
                    comment_user={comments[item].username}
                    timestamp={comments[item].timestamp}
                    likes={comments[item].likes} />
            </div>
        })
    }



    return (
        <div className='container  box_shadow rounded text-left bg-white mb-md-5 mb-sm-5 animate__animated animate__fadeInUp animate__slower'>

            <div className='row align-items-center justify-content-center my-2 pt-2'>
               { !props.ingeneralPublicProfile && <div className='col-md-10'>
                    <p className='fs-6 font-monospace font-large'>
                        Post by: <span className='posts-name '>
                        <Link to={`/community/user/${props.user_id}/profile`}>{props.post_user}</Link></span></p>
                </div>}
                <div className={` ${!props.ingeneralPublicProfile && "col-md-2"}`}>
                    <p className='fs-6 font-monospace ' style={{ fontSize: "10px" }}><span className='text-muted'>
                        {moment(props.time).fromNow()}</span></p>

                </div>
            </div>

            { props.post_content &&  <div className='row align-items-start justify-content-start my-1'>
                <div className='col-md-10 '>
                    <p className='fs-1 text-dark' >{props.post_content}</p>
                </div>
            </div>}

            <div className='row align-items-center justify-content-center'>
                <div className='col-md-'>
                    {props.post_image && <img src={props.post_image} alt="" width={'100%'} />}
                </div>
            </div>

            <div className='row align-items-center justify-content-center'>
                <div className='col-md-12'>
                    <div className='row align-items-center justify-content-between mx-2'>

                        <div className='col-3'>
                            <CommentModal post_id={props.post_id} />
                        </div>

                        <div className='col-5'>
                         <div className='row align-items-center justify-content-center'>
                                <button onClick={e => likeAPost(e, props.post_id)} className='btn btn-default'>
                                    <img src={love_image} alt="" width={'30px'}
                                        className='mx-1 animate__animated animate__tada animate__slow animate__infinite' />
                                </button>
                                <span className='font-weight-bold font-footer'>{likes}&nbsp; likes</span> 
                         </div>
                        </div>
                      
                        <div className='col-4 text-wrap font-footer w-100 '>
                            <a class="btn btn-default w-100 text-wrap font-footer" data-toggle="collapse" href={`#${props.time}`}
                                role="button" aria-expanded="false" aria-controls={props.time}>
                                {comments.length} comments
                            </a>

                        </div>



                    </div>
                    <div className='row align-items-center justify-content-center'>
                        <div className='col-md-12'>
                            <div class="collapse" id={props.time}>
                                <div class=" px-5 py-4 ">
                                    {displayComments()}

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )



}
